const ProfileImage = ({src,alt})=>(
	src!==''?
	<img
		alt={alt}
		className="m-1"
		style={{
			width:'40px',
			height:'40px',
			objectFit:'cover',
			borderRadius:'20px',
			backgroundColor:'#1171ef',
			flex:'0 0 auto'
		}}
		src={src} />
	:
	<span
		className="m-1"
		style={{
			width:'40px',
			height:'40px',
			borderRadius:'20px',
			backgroundColor:'#1171ef',
			color:'#eee',
			display:'flex',
			alignItems:'center',
			justifyContent:'center',
			flex:'0 0 auto'
		}}>
		<i className="fas fa-user" />
	</span>
)

export default ProfileImage